// extracted by mini-css-extract-plugin
export default {"label":"FormCheckbox_label__s8DMA","checked":"FormCheckbox_checked__wqH3f"};